import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './WhatsAppIcon.css'

const WhatsAppIcon = () => {
  return (
    <div id="whatsapp-icon">
      <a href="https://wa.me/+543537333120" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faWhatsapp} />
      </a>
    </div>
  );
}

export default WhatsAppIcon;
